import styled from "styled-components"
interface set_stake_props {
  anim: boolean
}

export const SetStakeWrapper = styled.div<set_stake_props>`
  width: 100%;
  height: 304px;
  border-radius: 20px;
  background: rgba(48, 30, 86, 0.85);
  overflow: hidden;
  animation: "appear";
  /* animation: ${({ anim }) => (anim ? "fadeOut" : "appear")}; */
  animation-duration: 0.167s;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  animation-fill-mode: forwards;
  .set-stake-wrapper {
    width: 100%;
    padding: 15px;
    animation: ${({ anim }) => (anim ? "disAappearContent" : "appearContent")};
    transform-origin: top;
    animation-duration: 0.167s;
    animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
    animation-fill-mode: forwards;
    svg {
      path {
        fill: #171731;
      }
    }
    span {
      width: 174px;
    }
    input {
      width: 100%;
    }
    p {
      font-size: 18px;
    }
    /* @keyframes appearContent {
      0%,
      50% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    @keyframes disAappearContent {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    } */
  }

  /* @keyframes appear {
    0% {
      height: 200px;
    }
    100% {
      height: 304px;
    }
  }
  @keyframes fadeOut {
    0% {
      height: 304px;
    }
    100% {
      height: 200px;
    }
  } */
`
